module.exports = [
  {
    name: 'dashboard',
    links: [
      {
        name: 'dashboard',
        path: '/dashboard',
        icon: 'ti-server'
      }
    ]
  },
  {
    name: 'settings',
    links: [
      {
        name: 'Covid',
        icon: 'ti-settings',
        path: '/covid'
      },
      {
        name: 'application',
        icon: 'ti-clipboard',
        path: '/application',
        isAdmin: true
      },
      {
        name: 'Contact Us',
        icon: 'ti-comment-alt',
        path: '/contact-us',
        notification: 'contact-us',
        isAdmin: true
      },
      {
        name: 'Language',
        icon: 'ti-server',
        path: '/language'
      },
      {
        name: 'Service Order',
        icon: 'ti-server',
        path: '/service-order'
      },
      {
        name: 'Payment Requisite',
        icon: 'ti-server',
        path: '/payment-requisite',
        isAdmin: true
      },
      // {
      //   name: 'Contacts',
      //   icon: 'ti-settings',
      //   path: '/contacts'
      // },
      // {
      //   name: 'Seo',
      //   icon: 'ti-sharethis',
      //   path: '/seo'
      // },
      // {
      //   name: 'Orders',
      //   icon: 'ti-credit-card',
      //   path: '/orders'
      // },
      {
        name: 'Currency',
        icon: 'ti-money',
        path: '/currency'
      },
      {
        name: 'Cookie',
        icon: 'ti-palette',
        path: '/cookie'
      },
      {
        name: 'Pages',
        icon: 'ti-book',
        path: '/pages'
      },
      {
        name: 'Certificate',
        icon: 'ti-check-box',
        path: '/certificate',
        notification: 'certificate',
        isAdmin: true
      },
      {
        name: 'User',
        icon: 'ti-user',
        path: '/user'
      },
      {
        name: 'Withdrawal',
        icon: 'ti-money',
        path: '/withdrawal',
        notification: 'withdrawal',
        isAdmin: true
      },
      {
        name: 'Credit Card',
        icon: 'ti-credit-card',
        path: '/credit-card',
        isAdmin: true
      },
      {
        name: 'Booking',
        icon: 'ti-agenda',
        path: '/booking',
        isAdmin: true
      },
      {
        name: 'Transaction',
        icon: 'ti-agenda',
        path: '/transaction',
        notification: 'transaction',
        isAdmin: true
      },
      {
        name: 'Faq',
        icon: 'ti-headphone-alt',
        path: '/faq'
      }
    ]
  },
  {
    links: [
      {
        name: 'Article',
        show: false,
        icon: 'ti-desktop',
        subMenu: [
          {
            name: 'Article',
            path: '/article'
          },
          {
            name: 'ArticleCategory',
            path: '/article-category'
          },
          {
            name: 'Tag',
            path: '/tag'
          }
        ]
      }
    ]
  },
  {
    links: [
      {
        name: 'Admin',
        show: false,
        icon: 'ti-user',
        isAdmin: true,
        subMenu: [
          {
            name: 'Admin',
            path: '/admins'
          }
          // {
          //   name: 'Roles',
          //   path: '/roles'
          // },
          // {
          //   name: 'Permissions',
          //   path: '/permissions'
          // }
        ]
      }
    ]
  },
  {
    links: [
      {
        name: 'Hotels',
        show: false,
        icon: 'ti-home',
        subMenu: [
          {
            name: 'Discount',
            path: '/discount'
          },
          {
            name: 'Room base',
            path: '/room-base'
          },
          {
            name: 'Room type',
            path: '/room-type'
          },
          {
            name: 'Company service',
            path: '/company-service'
          },
          {
            name: 'Hotel',
            path: '/hotel'
          },
          {
            name: 'Room',
            path: '/room'
          },
          {
            name: 'Facility',
            path: '/facility'
          },
          {
            name: 'Facility category',
            path: '/facility-category'
          }
        ]
      }
    ]
  },
  {
    links: [
      {
        name: 'Area',
        show: false,
        icon: 'ti-world',
        subMenu: [
          {
            name: 'Continent',
            path: '/continent'
          },
          {
            name: 'Country',
            path: '/country'
          },
          {
            name: 'Region',
            path: '/region'
          },
          {
            name: 'City',
            path: '/city'
          },
          {
            name: 'Sight',
            path: '/sight'
          },
          {
            name: 'District',
            path: '/district'
          }
        ]
      }
    ]
  }
]
